import {
  KentNodeClass,
  KentNodeOverlay,
  KentNodePool,
  KentFeature,
  KentWorkloadRightSizingFeature,
  KentFeatureTypeEnum,
  KentSpotInterruptionPredictionFeature,
  KentRebalancingFeature,
  KentPodMutationsFeature,
  KentClmFeature,
  KentFeatureConfig,
  KentClmFeatureConfig,
  KentPodMutationsFeatureConfig,
  KentRebalancingFeatureConfig,
  KentWorkloadRightSizingFeatureConfig,
  KentSpotInterruptionPredictionFeatureConfig,
  KentContinuousRebalancingFeatureConfig,
  KentContinuousRebalancingFeature,
} from '@cast/types-kent';

export const getNodePoolName = (nodePool: KentNodePool): string | undefined => {
  return nodePool.canonicalMetadata?.name;
};

export const getNodePoolNodeClassName = (
  nodePool: KentNodePool
): string | undefined => {
  return nodePool.spec?.template?.spec?.nodeClassRef?.name;
};

export const getNodeClassName = (
  nodeClass: KentNodeClass
): string | undefined => {
  return nodeClass.canonicalMetadata?.name;
};

// NodeOverlay has no canonicalMetadata yet — KENT-766 covers NodePool,
// EC2NodeClass and AKSNodeClass only. Keep reading the legacy metadata until
// the BE extends the shared ObjectMetadata to overlays.
export const getNodeOverlayName = (
  nodeOverlay: KentNodeOverlay
): string | undefined => {
  return nodeOverlay.metadata?.name;
};

type KentFeaturesMap = {
  [KentFeatureTypeEnum.WORKLOAD_RIGHT_SIZING]?: KentWorkloadRightSizingFeature;
  [KentFeatureTypeEnum.CONTINUOUS_REBALANCING]?: KentContinuousRebalancingFeature;
  [KentFeatureTypeEnum.REBALANCING]?: KentRebalancingFeature;
  [KentFeatureTypeEnum.SPOT_INTERRUPTION_PREDICTION]?: KentSpotInterruptionPredictionFeature;
  [KentFeatureTypeEnum.POD_MUTATIONS]?: KentPodMutationsFeature;
  [KentFeatureTypeEnum.CLM]?: KentClmFeature;
};

export const getKentFeaturesMap = (
  features: KentFeature[]
): KentFeaturesMap => {
  return features.reduce<KentFeaturesMap>((acc, feature) => {
    switch (feature.type) {
      case 'WORKLOAD_RIGHT_SIZING':
        acc.WORKLOAD_RIGHT_SIZING = feature;
        break;
      case 'CONTINUOUS_REBALANCING':
        acc.CONTINUOUS_REBALANCING = feature;
        break;
      case 'REBALANCING':
        acc.REBALANCING = feature;
        break;
      case 'SPOT_INTERRUPTION_PREDICTION':
        acc.SPOT_INTERRUPTION_PREDICTION = feature;
        break;
      case 'POD_MUTATIONS':
        acc.POD_MUTATIONS = feature;
        break;
      case 'CLM':
        acc.CLM = feature;
        break;
    }
    return acc;
  }, {});
};

type KentFeatureConfigsMap = {
  [KentFeatureTypeEnum.WORKLOAD_RIGHT_SIZING]?: KentWorkloadRightSizingFeatureConfig;
  [KentFeatureTypeEnum.REBALANCING]?: KentRebalancingFeatureConfig;
  [KentFeatureTypeEnum.SPOT_INTERRUPTION_PREDICTION]?: KentSpotInterruptionPredictionFeatureConfig;
  [KentFeatureTypeEnum.POD_MUTATIONS]?: KentPodMutationsFeatureConfig;
  [KentFeatureTypeEnum.CLM]?: KentClmFeatureConfig;
  [KentFeatureTypeEnum.CONTINUOUS_REBALANCING]?: KentContinuousRebalancingFeatureConfig;
};

export const getKentFeatureConfigsMap = (
  configs: KentFeatureConfig[]
): KentFeatureConfigsMap => {
  return configs.reduce<KentFeatureConfigsMap>((acc, config) => {
    switch (config.type) {
      case 'WORKLOAD_RIGHT_SIZING':
        acc.WORKLOAD_RIGHT_SIZING = config;
        break;
      case 'REBALANCING':
        acc.REBALANCING = config;
        break;
      case 'SPOT_INTERRUPTION_PREDICTION':
        acc.SPOT_INTERRUPTION_PREDICTION = config;
        break;
      case 'POD_MUTATIONS':
        acc.POD_MUTATIONS = config;
        break;
      case 'CLM':
        acc.CLM = config;
        break;
      case 'CONTINUOUS_REBALANCING':
        acc.CONTINUOUS_REBALANCING = config;
        break;
    }
    return acc;
  }, {});
};
